<template>
  <div class="index-module_articleWrap_2Zphx">
      <div class="zhemo">经典量化交易方法——没有秘密的多因子</div>
    
    <p class="index-module_textWrap_3ygOc">
      多因子选股采用一系列的因子（主要考虑使用价值、成长、质量以及市场等四大类因子）作为选股标准，将多个具有逻辑背景的因子策略相结合，选取在各个因子上综合得分较高的股票构建投资组合。通过这种方式选出来的股票通常不会在某个因子上有特别的短板，能够综合很多信息最后得出一个选股结果。同时，因为在不同的市场情况下，总有一些因子会发挥作用，因此多因子模型的表现相对来说也比较稳定。
    </p>
    <p class="index-module_textWrap_3ygOc"><b>多因子选股的灵魂在于透过多因子看市场逻辑</b></p>
    <p class="index-module_textWrap_3ygOc">
      比如高考，高校要从高中学生中录取学业优秀的学生进入大学，需要考察学生的综合成绩，对语文、数学、外语、物理、地理、化学等各门成绩进行测评，只有综合成绩高的学生，才能最终进入高校。这里，每门功课都相当于一个候选因子，每一个因子的情况——分数都十分透明，可以帮助高校非常清晰地看清学生的实力。
    </p>
    <p class="index-module_textWrap_3ygOc">而在量化投资领域，多因子选股策略的应用范围已经非常广泛。</p>
    
    <img src="../../../assets/img/gar14-1.jpg" alt="">
    <figure>
      
    </figure>
    
    <p class="index-module_textWrap_3ygOc">
      多因子模型通过对各因子的持续跟踪研究，深入分析Alpha因子的作用条件，并关注其背后的市场逻辑，便可清楚的知道超额收益从哪里来，也很清楚承担的是哪一部分市场风险。
    </p>
    
    <img src="../../../assets/img/gar14-1.jpg" alt="">
    <figure>
      
    </figure>
    <p class="index-module_textWrap_3ygOc"><br /><b>候选因子的选取</b></p>
    <p class="index-module_textWrap_3ygOc">
      多因子模型选股最重要的一点找出哪些因子对企业来说是“健康”的因子。Fama和French
      1992年对美国股票市场决定不同股票回报率差异的因素的研究发现，股票的市场的Beta值不能解释不同股票回报率的差异，而上市公司的市值、账面市值比、市盈率可以解释股票回报率的差异。诺奖得主EugeneFama通过对大量股票中某些共同特征进行筛选，从而得到有别于大盘因子的两个新因子：规模与价值。这个模型能很好地解释股票的预期回报。后来，该模型又加上了动量因子，成为四因子模型。
    </p>
    <p class="index-module_textWrap_3ygOc">
      如今通过研究人员的不断分析，因子的数量已经多达成百上千个。候选因子的选择主要依赖于经济逻辑和市场经验，但选择更多和更有效的因子无疑是增强模型信息捕获能力，提高收益的关键因素之一。
    </p>
    <p class="index-module_textWrap_3ygOc"><b>模型有效性检测</b></p>
    <p class="index-module_textWrap_3ygOc">
      到底哪些因子是有效的呢，是PE有效还是ROE有效？到底是采用1个月做调仓周期，还是3个月做调仓周期。这些因子和参数的有效应只能通过历史数据的回测来加以分析。
    </p>
    <p class="index-module_textWrap_3ygOc">
      模型回测的目的是为了获得有效因子和参数，再利用这些有效因子和参数筛选股票，然后构造投资组合进行投资，从而获得正的alpha收益。
    </p>
    
    <img src="../../../assets/img/gar14-1.jpg" alt="">
    <figure>
      
    </figure>
    
    <p class="index-module_textWrap_3ygOc">
      多因子选股策略虽然采用的是量化的投资方法，但背后体现的还是基金经理的主动选股思路，相较传统的主动选股型基金，多因子选股策略因为具有独特的优势，而被越来越多国内的量化投资者所采纳。
    </p>
    <figure>
      
    </figure>
    <p class="index-module_textWrap_3ygOc"></p>
    <p class="free">（来源：黄瓜量化科技）</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>